module.exports = __webpack_public_path__ + "img/si.925e1976.svg";